import { render, staticRenderFns } from "./AllergensPdfViewer.vue?vue&type=template&id=56f271bc&scoped=true"
import script from "./AllergensPdfViewer.vue?vue&type=script&lang=js"
export * from "./AllergensPdfViewer.vue?vue&type=script&lang=js"
import style0 from "./AllergensPdfViewer.vue?vue&type=style&index=0&id=56f271bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f271bc",
  null
  
)

export default component.exports